"use client";

import { Navbar, Dropdown, Avatar } from "flowbite-react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { Badge, Button, Tooltip } from "antd";
import { RiLogoutCircleRLine } from "react-icons/ri";
import EventEmitter from "../../utils/eventEmitter";
import PosCloseSessionModal from "../modals/PosCloseSessionModal";
import { useEffect, useState } from "react";
import { IoMdExit } from "react-icons/io";
import { ImExit } from "react-icons/im";






const PosSessionHeader = ({error, success, state, dispatch, createNewOrder, cashier, user}) => {
  // const user = useOutletContext();
  const navigate = useNavigate();

  const goToOrders = () => navigate('/pos/session/sells/session-orders');
  
  const newOrder = () => {
    const orders = createNewOrder(state, user.id);
    dispatch({event: 'NEW_ORDER', orders: orders});
    navigate(0);
  }

  // console.log(state.orders)
  const closeSession = () => {
    const myOrders = state.orders.filter(order => order.status === 'paid').flatMap(order => order.paymentLines);
    // const summedPayments = myOrders.sort((a, b)=> b.is_cash - a.is_cash).reduce((acc, payment) => {
    //   if (acc['name'] === payment.name) {
    //     acc['amount'] = [payment.name] += payment.amount * 1;
    //     acc['is'][]
    //   } else {
    //     acc['name']['payment'] = payment.amount * 1;
    //   }
    //   return acc;
    // }, {});
    let payments = [];

    myOrders.sort((a, b)=> b.is_cash - a.is_cash).forEach(payment => {
      let obj = {name: payment.name, amount: payment.amount * 1, is_cash: payment.is_cash ? true : false};
      let index = payments.findIndex(pay => pay.name === payment.name);
      if (index === -1) {
        payments.push(obj);
      }else {
        payments[index]['amount'] += payment.amount * 1;
      }
    });

    let orders_ = {totalAmount: 0, totalPaid: 0, no_orders: 0}; 
    state.orders.forEach(order => {
      if (order.status === 'paid') {
        orders_['totalAmount'] += order.totalAmount * 1;
        orders_['totalPaid'] += order.totalPaid * 1; 
        orders_['no_orders'] += 1;
      }
    });
    orders_['payments'] = payments;


    EventEmitter.dispatch('close_session', {open: true, orders: orders_});
  }

  const changeCashier = () => {
    let currentUser = localStorage.getItem('caspian_pos_cashier');
    let currentUser_ = JSON.parse(currentUser);
    currentUser_.pin = null;
    localStorage.setItem('caspian_pos_cashier', JSON.stringify(currentUser_));
    navigate('/pos/session');
  }

  const goToOverview = () => navigate('/pos');

  return (
    <Navbar fluid rounded className="mb-3 border-b-2 rounded-none py-1 pb-0 bg-[#05bcc4] header">
      <div className="flex items-center justify-center"> 
        <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Point of Sales</span>
        <Tooltip title='Exit to Overview' className="ms-3">
          <div className="bg-[#05bcc4] rounded" style={{width: 'fit-content'}}>
            <Button type="text" icon={<ImExit className="w-100 hover:text-red-500"/>} className="text-lg text-red-700 w-100" onClick={goToOverview} />
          </div>
        </Tooltip>
      </div>

      <div className="flex">
      

      <Button type="primary" className="me-2" onClick={newOrder}>New Order</Button>

      <Badge count={state.orders.filter(order => order.is_ordered === true).length}>
        <Button type="text" onClick={goToOrders}>Orders</Button>
      </Badge>

      </div>
      <div className="flex items-center justify-end gap-x-2" style={{width: '30%'}}>
        
        <Dropdown
          arrowIcon={false}
          inline
          label={<span className="mx-2 text-lg font-semibold uppercase">{cashier.name}</span>}
        >
          <Dropdown.Item onClick={changeCashier}>Change Cashier</Dropdown.Item>
        </Dropdown>

        <div className="bg-red-700 rounded">
        <Button type="text" className="text-white" icon={<RiLogoutCircleRLine />} onClick={closeSession}>Close</Button>
        </div>
      </div>
      <PosCloseSessionModal error={error} success={success} state={state} />
    </Navbar>
  );
}




export default PosSessionHeader;